export default "__VITE_ASSET__B1A_cPzw__"